export const FirebaseConfig = {
	"projectId": "uprun-47529",
	"appId": "1:454566144709:web:fbfb2d903e821d216e9eac",
	"databaseURL": "https://uprun-47529-default-rtdb.firebaseio.com",
	"storageBucket": "uprun-47529.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBN1COqGyT9_VyIeXw6ESJIJs3pAtTBtHg",
	"authDomain": "uprun-47529.firebaseapp.com",
	"messagingSenderId": "454566144709"
}; 